module.exports = __webpack_public_path__ + "img/android-chrome-192x192.f130a0b7.png";